// @flow
import * as React from 'react';

import { getComponentName } from 'common/utils/ReactUtils';

import usePermissionMatch from './usePermissionMatch';
import AccessDeniedScreen from './AccessDeniedScreen';
import { type Operations } from './types';

const withRoutePermissionCheck = <TProps>(
    WrappedComponent: React.AbstractComponent<TProps>,
    operations: Operations
): React.AbstractComponent<TProps> => {
    const WithRoutePermissionCheckComponent = (props: TProps) => {
        const isMatching = usePermissionMatch(operations);
        return isMatching ? (
            <WrappedComponent {...props} />
        ) : (
            <AccessDeniedScreen />
        );
    };

    WithRoutePermissionCheckComponent.displayName = `withRoutePermission(${getComponentName(
        WrappedComponent
    )})`;

    return WithRoutePermissionCheckComponent;
};

export default withRoutePermissionCheck;
